import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Input, FormFeedback, Label, Row, Col } from "reactstrap"
import { AddIcon, CancelIcon} from "../../common/icons"
import { IOrg } from "../../../types/org"
import PositionTypeahead from "../../common/typeahead/position-typeahead"
import Select from "../../common/select/select"
import { IValueListLight } from "../../../types/valuelist"
import { useEffect, useState } from "react"
import { IPosition, IPositionInput, IPositionTitle } from "../../../types/position"
import { useApolloClient, useLazyQuery, useMutation } from "@apollo/client"
import { ORG_VALUE_LISTS } from "../../../graphql/valuelist-gql"
import { CREATE_POSITION_ROLE, GET_ORG_POSITIONS, GET_ORG_ROLES } from "../../../graphql/position-gql"
import { notifySuccess } from "../../../services/notification"
import { messages } from "../../../i18n/message"
import { LOCALES } from "../../../i18n/locales"
import { formatExcludeComma } from "../../../types/constants"
import { Toggleable } from "../../../hook/useToggle"
import Info from "../../common/info"
import Button from "../../common/button"
import SpinnerOverlay from "../../common/spinner/spinner"

interface PositionRoleCreateProps extends Toggleable {
    org:  IOrg;
    isRole: boolean;
}

const PositionRoleCreateModal = (props: PositionRoleCreateProps) => {
    const {org, isOpen, toggle, isRole} = props
    const [hasManagement,setHasManagement] = useState(false)
    const client = useApolloClient()
    const { orgValueLists } =  client.readQuery({query: ORG_VALUE_LISTS})
    const [ getCurrentPositions ] = useLazyQuery(GET_ORG_POSITIONS,{
        variables:{orgId:org.id},
        onCompleted: (data) => {
        if (data?.org?.positions) {
            const pos = data?.org?.positions?.find((position:IPosition)=>{return position.managementIndicator})
            setHasManagement(!!pos)
        }
    }});
    const [ createPositionOrRole, {loading} ] = useMutation(CREATE_POSITION_ROLE);
    const [relTypeId,setReltypeId] = useState<number>(orgValueLists.orgPosRelTypes[0].id);
    const [selectedPositionTitle,setSelectedPositionTitle] = useState<IPositionTitle>({positionTitleId:0,positionName:""});
    const [titleError,setTitleError] = useState<string>('');
    const [prefixLengthError,setPrefixLengthError] = useState<string>('');
    const [prefixCharError,setPrefixCharError] = useState<string>('');
    const [suffixLengthError,setSuffixLengthError] = useState<string>('');
    const [suffixCharError,setSuffixCharError] = useState<string>('');
    const [managementIndicatorError,setManagementIndicatorError] = useState<string>('');
    const [valid,setValid] = useState<boolean>(true);
    const [fullTitle,setFullTitle] = useState<String>('');
    const [editedPosition, setEditedPosition] = useState<IPositionInput>(
        {positionTitleId:0, positionHonorificId:0, positionPrefix:'',positionSuffix:'', positionName:'',
         bilingualIndicator:false, managementIndicator:false
        }
    )

    useEffect(()=>{getCurrentPositions()},[org,getCurrentPositions])

    useEffect(()=>{
        const list:IValueListLight[] = isRole?(orgValueLists?.orgRoleRelTypes):(orgValueLists?.orgPosRelTypes)
        const type:IValueListLight|undefined = list?.find((item:IValueListLight)=>item.code==='DIRECT')
        const typeId:number = type ? type.id:0;
        setReltypeId(typeId);
    },[isRole,orgValueLists])

    useEffect(() => {
        setEditedPosition({positionTitleId:0, positionHonorificId:0, positionPrefix:'',positionSuffix:'', positionName:'',
            bilingualIndicator:false, managementIndicator:false
        })
        setSelectedPositionTitle({positionTitleId:0,positionName:""})
        setReltypeId(isRole?orgValueLists.orgRoleRelTypes[0].id:orgValueLists.orgPosRelTypes[0].id)
    },[toggle,orgValueLists.orgPosRelTypes,orgValueLists.orgRoleRelTypes,isRole])

    useEffect(() => {
        //console.log('editedPosition?.positionTitle:',editedPosition?.positionTitle)
        setValid(editedPosition?.positionTitleId!==0
            && !titleError
            && !prefixCharError && !prefixLengthError
            && !suffixCharError && !suffixLengthError
            && !managementIndicatorError )
    },[titleError,prefixCharError,prefixLengthError,suffixCharError,suffixLengthError,editedPosition,managementIndicatorError]);

    useEffect(()=>{
        let honorific = '';
        if(editedPosition.positionHonorificId!==0 && editedPosition.positionHonorificId!==-1){
            const orgValueList = orgValueLists.posHonorifics.find((item:IValueListLight)=>item.id===editedPosition.positionHonorificId)
            honorific=orgValueList?orgValueList.label+' ':'';
        }
        const myfullTitle =
            (
                honorific
                +(editedPosition?.positionPrefix?editedPosition.positionPrefix+' ':'')
                + (selectedPositionTitle?selectedPositionTitle.positionName:'')
                + (editedPosition?.positionSuffix?' '+editedPosition.positionSuffix:'')
            )
        setFullTitle(myfullTitle)

    },[editedPosition.positionHonorificId,editedPosition.positionPrefix,selectedPositionTitle,editedPosition.positionSuffix,orgValueLists.posHonorifics])

    useEffect(() => {

        //console.log("editedPosition:",editedPosition)

        if(editedPosition?.positionPrefix && editedPosition?.positionPrefix?.length>100)
            setPrefixLengthError(messages[LOCALES.ENGLISH].ERROR['5612'])
        else
            setPrefixLengthError('')

        if(editedPosition?.positionPrefix && formatExcludeComma.test(editedPosition?.positionPrefix))
            setPrefixCharError(messages[LOCALES.ENGLISH].ERROR['5613'])
        else
            setPrefixCharError('')

        if(editedPosition?.positionSuffix && editedPosition?.positionSuffix?.length>100)
            setSuffixLengthError(messages[LOCALES.ENGLISH].ERROR['5612'])
        else
            setSuffixLengthError('')

        if(editedPosition?.positionSuffix && formatExcludeComma.test(editedPosition?.positionSuffix))
            setSuffixCharError(messages[LOCALES.ENGLISH].ERROR['5613'])
        else
            setSuffixCharError('')

        if(hasManagement&&editedPosition.managementIndicator)
            setManagementIndicatorError(messages[LOCALES.ENGLISH].ERROR['5614'])
        else
            setManagementIndicatorError('')

    }, [editedPosition.positionPrefix,editedPosition.positionSuffix,editedPosition.managementIndicator,hasManagement])

    const titleSelected = (positionTitle: IPositionTitle | null) => {
        setSelectedPositionTitle(positionTitle||{positionTitleId:0,positionName:''});
        setEditedPosition({ ...editedPosition, positionTitleId: positionTitle?.positionTitleId||0 })
    }
    const onPositionPrefixChange = (event: any) => {
        setEditedPosition({ ...editedPosition, positionPrefix: event.target.value})
    }
    const onPositionSuffixChange = (event: any) => {
        setEditedPosition({ ...editedPosition, positionSuffix: event.target.value })
    }
    const onHonorificChange = (event: any) => {
        setEditedPosition({ ...editedPosition, positionHonorificId: event.target.value })
    }
    const onManagementIndicatorChange = (event: any) => {
        setEditedPosition({ ...editedPosition, managementIndicator: !editedPosition.managementIndicator })
    }
    const onbilingualIndicatorChange = (event: any) => {setEditedPosition({ ...editedPosition, bilingualIndicator: !editedPosition.bilingualIndicator })}
    const getRefetchQuery = () => {
        if(isRole)
            return [{query: GET_ORG_ROLES, variables: {  orgId: org.id||0 } }]
        else
            return [{query: GET_ORG_POSITIONS, variables: {  orgId: org.id||0 } }]
    }

    const onCreatePositionHandle = () => {
        const inputPosition = {...editedPosition}
        delete inputPosition.positionName;
        //console.log("org:",org.id)
        //console.log("inputPosition:",inputPosition)
        createPositionOrRole({
            variables: {
                orgId: org.id||0,
                relTypeId : relTypeId,
                isRole: isRole,
                input: {
                    ...inputPosition
                }
            },
            refetchQueries: getRefetchQuery(),
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle();
                //console.log("data:",data)
                data && notifySuccess()
            }
        })
    }


    return (<>
        {loading && <SpinnerOverlay />}
        <Modal size="lg" isOpen={isOpen} toggle={toggle} scrollable backdrop="static" autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>{`Add a ${isRole?'Role':'Position'}`}</ModalHeader>
            <ModalBody>
                
                <Row>
                    <Info><b>Full Title Preview:</b>&nbsp;<b><i>{fullTitle}</i></b></Info>
                </Row>
                <Form  className="oms-container">
                        <Row>
                            <Col sm={4}><Label for="pos-info-title" aria-label='title'>Title: (required)</Label></Col>
                            <Col sm={8}>
                                <PositionTypeahead elementId="pos-info-title" org={org} positionTitleSelected={titleSelected} init={selectedPositionTitle} validate={setTitleError} limit={20} isRole={isRole} autoFocus={true}/>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={4}><Label for='pos-info-prefix' aria-label='pos-info-prefix'>Prefix:</Label></Col>
                            <Col sm={8}>
                                <Input id="pos-info-prefix" aria-labelledby="pos-info-prefix"  
                                    value={editedPosition?.positionPrefix||''}
                                    placeholder={`Enter a prefix for the ${isRole?'role':'position'} title`}
                                    onChange={onPositionPrefixChange}
                                    invalid={!!prefixLengthError || !! prefixCharError}/>
                                <FormFeedback>{prefixLengthError}</FormFeedback>
                                <FormFeedback>{prefixCharError}</FormFeedback>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={4}><Label for="pos-info-suffix" aria-label='suffix'>Suffix:</Label></Col>
                            <Col sm={8}>
                                <Input id="pos-info-suffix"  value={editedPosition?.positionSuffix||'' }
                                    placeholder={`Enter a suffix for the ${isRole?'role':'position'} title`}
                                    onChange={onPositionSuffixChange}
                                    invalid={!!suffixLengthError || !! suffixCharError}/>
                                <FormFeedback>{suffixLengthError}</FormFeedback>
                                <FormFeedback>{suffixCharError}</FormFeedback>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={4}><Label for="pos-info-honorific" aria-label='honorific'>Honorific:</Label></Col>
                            <Col sm={8}>
                                <Select id="pos-info-honorific"  value={editedPosition?.positionHonorificId || 0 } onChange={onHonorificChange}>
                                    <option value='0' disabled>Select an honorific</option>
                                    <option value='-1'></option>
                                    {orgValueLists.posHonorifics.map((item: IValueListLight) => <option key={item.id} value={item.id}>{item.label}</option>)}
                                </Select>
                            </Col>
                        </Row>
                        {!isRole &&
                            <Row>
                                <Col sm={4}>
                                    <Label for="pos-info-managementIndicator" check>Is this position responsible for the organization?</Label></Col>
                                <Col sm={8}>
                                    <Input
                                        id="pos-info-managementIndicator"
                                        type="checkbox"
                                        style={{verticalAlign:'middle'}}
                                        checked={editedPosition?.managementIndicator||false}
                                        onChange={onManagementIndicatorChange}
                                        invalid={!!managementIndicatorError}
                                        aria-describedby={managementIndicatorError ? 'managementIndicatorError' : undefined}
                                        />
                                        {managementIndicatorError && (
                                            <FormFeedback id="managementIndicatorError">
                                                {managementIndicatorError}
                                            </FormFeedback>
                                        )}
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col sm={4}><Label for="pos-info-bilingualIndicator" check>Is this {isRole? 'Role': 'Position'} bilingual?</Label></Col>
                            <Col sm={8}>
                                <Input id="pos-info-bilingualIndicator"
                                    type="checkbox"
                                    style={{verticalAlign:'middle'}}
                                    checked={editedPosition?.bilingualIndicator||false}
                                    onChange={onbilingualIndicatorChange}/>
                            </Col>
                        </Row>         
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onCreatePositionHandle} disabled={!valid}><AddIcon/> Add</Button>
                <Button color="secondary" onClick={toggle}><CancelIcon/> Cancel</Button>
            </ModalFooter>
        </Modal>
        </>
    )
}

export default PositionRoleCreateModal;

